import { createSelector } from 'reselect';
import { getProfileId } from './getProfileId';

const getAllMedia = (state) => state.ProfileVenue.loadMedia.data || {};

export const getProfileMedia = createSelector(
	getAllMedia,
	getProfileId,
	(data, id) => {
		return data ? data[id] : {};
	},
);
